import { ProviderEntryPointVersionEnum } from '@dynamic-labs/sdk-api-core';
import { constants } from '@zerodev/sdk';

export const getEntryPoint = (entryPoint?: string) => {
  if (entryPoint === ProviderEntryPointVersionEnum.V6) {
    return constants.getEntryPoint('0.6');
  }

  // default to v7
  return constants.getEntryPoint('0.7');
};
